module.exports = __webpack_public_path__ + "img/alipay.369e51d6.png";